/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum SuitamoiApiSubStatusCode {
    None = 0,
    AccountState_Locked = 1,
    AccountState_RequiresTfa = 2,
    AccountState_InvitationSent = 3,
}
